'use client';

import { usePathname } from 'next/navigation';

import { ChevronLeftIcon } from 'lucide-react';

import { Link } from '~/components/common/link';

export function GamesMoreGamesLink() {
  const pathname = usePathname();

  if (pathname === '/games') {
    return null;
  }

  return (
    <Link
      href='/games'
      className='font-greycliff-bold col-start-1 row-start-1 flex items-center gap-2.5 text-xs text-white'
    >
      <div className='max-sm:rounded-full max-sm:bg-white/5 max-sm:p-2'>
        <ChevronLeftIcon className='size-4 -translate-y-px' />
      </div>
      <span className='max-sm:sr-only'>More Games</span>
    </Link>
  );
}
